//removeIf(production)
import ClaroluzProgressIndicator from "../../../../../infra/services/claroluz-progress-indicator";
//endRemoveIf(production)

class ClaroluzProgressIndicatorWorker {
    private options: object;
    private element: any;
    private elementMini: any;

    constructor() {
        this.options = {
            fontFamily: "Oxygen",
            drawPercentageSign: true,
            drawBubbles: false,
            size: 200,
            borderWidth: 10,
            backgroundColor: "#0DC2BC",
            foregroundColor: "#fff",
            foregroundFluidLayer: {
                fillStyle: "#0DC2BC",
                angularSpeed: 90,
                maxAmplitude: 11,
                frequency: 25,
                horizontalSpeed: -200
            },
            backgroundFluidLayer: {
                fillStyle: "#0DC2BC",
                angularSpeed: 100,
                maxAmplitude: 13,
                frequency: 23,
                horizontalSpeed: 230
            }
        };

        // this.element = new ClaroluzProgressIndicator(document.getElementById('fluid-meter-loader') as HTMLElement, this.options);
        this.elementMini = new ClaroluzProgressIndicator(document.getElementById('fluid-meter-mini') as HTMLElement, this.options);
        this.startEvent();
    }

    private startEvent() {
        document.addEventListener('claroluz_loading_start', (event: any) => {
            let percentage = 0;
            let timeout = event.detail.timeout * 1000;
            let intervalTime = timeout / 100;

            let interval = setInterval(() => {
                percentage += 1;
                // this.element.updateProgress(percentage);
                this.elementMini.updateProgress(percentage);

                if (percentage >= 100) {
                    percentage = 0;
                    clearInterval(interval);
                }
            }, intervalTime);
        });
    }
}

//removeIf(production)
export default ClaroluzProgressIndicatorWorker;
//endRemoveIf(production)